


















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "AudioAttachmentPlayerView",
  components: { BaseIconButton, BaseIcon },
  props: {
    formattedRemainingTime: { type: String, default: 0 },
    isAudioPlaying: { type: Boolean, default: 0 },
  },
});
